{
  "title": "PIER CARNIVAL",
  "illustration": {
    "asset": "d3-cabinet-original",
    "tile": 2
  },
  "rulesheet": [
    "Complete both target banks for four tickets and higher bonus.",
    "Collect 12 tickets. Prize Booth starts Prize Multiball.",
    "In multiball, Spinner adds tickets. Prize Booth pays jackpots."
  ],
  "lighting": {
    "version": 1,
    "palette": {
      "idle": "#FFE3AA",
      "active": "#E45272",
      "hit": "#FFF2CD",
      "award": "#FFCF60"
    },
    "modes": {
      "prizeMultiball": "#EB76B2"
    },
    "cues": {
      "multiball": "multiball",
      "jackpot": "jackpot",
      "qualified": "bank"
    },
    "paths": {}
  }
}
